module.exports = __webpack_public_path__ + "media/images/metronic/social/yahoo-99e0ee0ee770a54c8197d1ecf78eb94b.png";